// src/components/brandCustomization/shared/PreviewModal.jsx
import React from 'react';
import { FaTimes, FaEye } from 'react-icons/fa';

/**
 * PreviewModal - Modal genérico para previsualizaciones
 */
const PreviewModal = ({
    isOpen,
    onClose,
    title,
    children,
    maxWidth = 'max-w-6xl'
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
                {/* Overlay */}
                <div
                    className="fixed inset-0 bg-gray-500 opacity-75 transition-opacity"
                    aria-hidden="true"
                    onClick={onClose}
                />

                {/* Modal Container */}
                <div className={`relative bg-white rounded-lg sm:rounded-xl text-left overflow-hidden shadow-xl transform transition-all w-full ${maxWidth} mx-auto my-4 sm:my-8`}>
                    {/* Header */}
                    <div className="px-4 sm:px-6 pt-4 sm:pt-6 pb-3 sm:pb-4">
                        <div className="flex justify-between items-center pb-3 sm:pb-4 border-b border-gray-200">
                            <h3 className="text-base sm:text-lg font-semibold text-gray-900 flex items-center">
                                <FaEye className="w-4 h-4 sm:w-5 sm:h-5 mr-2 text-blue-500 flex-shrink-0" />
                                <span className="truncate">{title}</span>
                            </h3>
                            <button
                                onClick={onClose}
                                className="text-gray-400 hover:text-gray-600 transition-colors p-1 flex-shrink-0 ml-2"
                                aria-label="Cerrar"
                            >
                                <FaTimes className="h-5 w-5 sm:h-6 sm:w-6" />
                            </button>
                        </div>
                    </div>

                    {/* Preview Content */}
                    <div className="px-4 sm:px-6 pb-4 sm:pb-6 overflow-y-auto" style={{ maxHeight: 'calc(100vh - 200px)' }}>
                        {children}
                    </div>

                    {/* Footer */}
                    <div className="px-4 sm:px-6 py-3 sm:py-4 bg-gray-50 border-t border-gray-200">
                        <button
                            onClick={onClose}
                            className="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                        >
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreviewModal;

